<template>
  <div>
    <shop-head currentPageName="company"></shop-head>

    <div class="content_wrapper">
      <div class="companyTitle">
        <span
          >{{ detail.companyName || "--" }}
          <!-- <i style="margin: 0px 5px" class="el-icon-thumb"></i> -->
          <i style="margin: 0px 5px" class="el-icon-star-on"></i>
          <span style="font-size: 15px; margin-right: 30px"
            >{{ $t("足迹") }}12</span
          >
        </span>
        <!-- <span class="companyTab" @click="GoToProint">{{ $t("首页") }}</span> -->
        <span class="companyTab" @click="goShops">{{ $t("全部商品") }}</span>
        <!-- <span class="companyTab" @click="">{{ $t("品牌故事") }}</span> -->
        <!-- <span class="companyTab" @click="">{{ $t("商务合作") }}</span> -->
        <span class="companyTab" @click="GoToProint"
          >{{ $t("企业指数") }}<sup>{{ detail.point }}</sup></span
        >
        <span style="float: right">
          <i
            style="
              margin-right: 20px;
              font-size: 30px;
              color: #1684fc;
              vertical-align: sub;
            "
            class="el-icon-phone"
          ></i>
          {{ detail.legalPersonPhone }}
        </span>
        <span style="float: right; margin-right: 60px"
          ><i
            style="
              margin-right: 20px;
              font-size: 30px;
              color: #1684fc;
              vertical-align: sub;
            "
            class="el-icon-s-custom"
          ></i
          >{{ $t("联系人") }} : {{ detail.legalPersonName }}</span
        >
        <div style="padding: 0; margin: 0">
          <img src="../../assets/images/企业等级.png" style="width: 120px" />
          <span
            style="
              color: #ef488a;
              padding: 5px 8px;
              border-radius: 5px;
              font-size: 14px;
              background-color: #fce5e7;
              margin-right: 10px;
            "
            >{{ $t("外资独资") }}</span
          >
          <span
            style="
              color: #ef488a;
              padding: 5px 8px;
              border-radius: 5px;
              font-size: 14px;
              background-color: #fce5e7;
            "
            >1000{{ $t("人") }}</span
          >
        </div>
      </div>
      <img
        style="width: 60%; height: 600px; object-fit: fill"
        :src="
          detail.facadePic ||
          'https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh4af5446ec34a42659ad50c4f6d092327%E4%BC%81%E4%B8%9A%E5%BE%AE%E4%BF%A1%E6%88%AA%E5%9B%BE_17316637228449(1).png'
        "
        alt=""
      />
      <div class="staticInfo">
        <br />
        <br />
        <b>{{ $t("企业信息") }}</b>
        <p>{{ detail.introduction || "--" }}</p>
        <b>{{ $t("主营品类") }}</b>
        <p>{{ detail.category || "--" }}</p>
        <b>{{ $t("主营车型") }}</b>
        <p>{{ detail.mainCar || "--" }}</p>
        <b>{{ $t("配套客户") }}</b>
        <p>{{ detail.brand || "--" }}</p>
        <b>{{ $t("认证专利") }}</b>
        <p>
          <span
            v-for="item in detail.authInfo ? detail.authInfo.split(',') : '-'"
            :key="item"
          >
            {{ $t(item) }}
          </span>
        </p>
        <h1 style="border-bottom: 2px solid #1684fc">{{ $t("库存") }}</h1>
      </div>
      <div class="content" v-if="products.length > 0">
        <div class="product" v-for="item in products" :key="item.id">
          <img
            :src="
              item.picture != '0'
                ? item.picture.split(',')[0]
                : item.companyLogo
            "
            alt=""
          />
          <p>{{ item.partsNo }}</p>
          <b>{{ lang == "zh" ? item.cname : item.ename }}</b>
          <p style="color: red">￥{{ item.price || "询价" }}</p>
          <div>
            <el-input-number
              v-model="item.quantity"
              size="mini"
              :min="1"
            ></el-input-number
            >&nbsp;
            <el-button type="danger" size="mini" round>{{
              $t("立即抢购")
            }}</el-button
            >&nbsp;
            <i
              @click="addCart(item.id, item.quantity)"
              style="color: red; font-size: 18px"
              class="el-icon-shopping-cart-2"
            ></i>
          </div>
        </div>
      </div>
      <div class="noData" v-else>
        <h1>{{ $t("暂无商品") }}</h1>
      </div>
      <el-pagination
        v-if="products.length"
        background
        :current-page="currentPage"
        :page-sizes="[12, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleChangeSize"
        @current-change="handleSearch"
      />
    </div>

    <common-footer></common-footer>
  </div>
</template>

<script>
import shopHead from "../../components/shop/head";
import commonFooter from "../../components/common/footer";
import breadcrumb from "../../components/common/breadcrumb";
import { productsList } from "../../apis/shop";
import { cartSave, companyDetail } from "../../apis/company";
import { RouterLink } from "vue-router";

export default {
  components: {
    shopHead,
    commonFooter,
    breadcrumb,
  },

  filters: {
    formatDate(time) {
      return time ? new Date(+time).toLocaleString() : "--";
    },
  },
  data() {
    const { id } = this.$route.query;
    return {
      ...this.$route.query,
      total: 0,
      currentPage: 1,
      pageSize: 12,
      search: {
        manufacturerCname: [],
        categoryFirstSup: [],
        companyId: id || "",
        currentPage: 1,
        pageSize: 12,
      },
      detail: {},
      products: [],
      num: 1,
      lang: "",
    };
  },
  created() {
    this.lang = localStorage.getItem("language") == "zh" ? "zh" : "en";
    this.getList();
  },
  methods: {
    async getList() {
      const products = (await productsList(this.search)).data.data.list;
      products.map((item) => (item.quantity = 1));
      this.products = products;
      this.total = (await productsList(this.search)).data.data.total;
      const detail = (await companyDetail({ id: this.id })).data;
      this.detail = detail;
    },
    async addCart(partsId, quantity) {
      try {
        await cartSave({ partsId, quantity });
        this.$message.success("加入购物车成功!");
      } catch (error) {
        this.$message({
          type: "error",
          message: error.message,
        });
      }
    },
    handleChangeSize(value) {
      this.pageSize = value;
      this.search.pageSize = value;
      this.handleSearch();
    },
    // 查询数据
    handleSearch(currentPage = 1) {
      this.currentPage = currentPage;
      this.search.currentPage = currentPage;
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.search,
          ...this.$route.query,
          currentPage,
        },
      });
      this.getList();
    },
    goShops() {
      window.scrollTo(0, 1030);
    },
    // 跳转企业指数
    GoToProint() {
      // console.log(this.companyName)
      this.$router.push({
        path: "/company_exponent",
        query: {
          id: this.search.companyId,
          companyName: this.companyName,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content_wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  .companyTitle {
    // display: flex;
    padding: 5px;
    width: 60%;
    // padding-left: 18.5%;
    font-size: 20px;
    // background-color: #f6f4f4 !important;
    z-index: 99;
    .companyTab {
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      margin: 0px 10px;
    }
    .companyTab:hover {
      color: #66b1ff;
    }
  }
  .staticInfo {
    width: 60%;

    b {
      padding-bottom: 10px;
      border-bottom: 2px solid #1684fc;
      font-size: 18px;
    }
    p {
      margin: 20px 0;
      span {
        color: #fff;
        display: inline-block;
        background-color: #16a753;
        border-radius: 5px;
        padding: 10px 30px;
        margin-right: 20px;
        margin-bottom: 15px;
      }
    }
  }
  .content {
    width: 60%;
    // border: 1px solid red;
    display: flex;
    align-content: center;
    // justify-content: center;
    flex-wrap: wrap;

    .product {
      box-sizing: border-box;
      width: 22.2%;
      text-align: center;
      padding: 20px 2px;
      margin: 10px;
      background-color: #fff;
      box-shadow: 0px 0px 10px #ccc;
      img {
        width: 80%;
        height: 130px;
      }

      .el-input-number--mini {
        width: 85px;
      }
    }
  }

  .noData {
    width: 60%;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>